import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";

const CountryCtx = createContext(null);
const DEFAULT_CURRENCY = { code: "INR", name: "Indian Rupee", symbol: "₹", flag: "🇮🇳", inr_per_unit: 1.0 };

export function CountryProvider({ children }) {
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([DEFAULT_CURRENCY]);
  const [slug, setSlug] = useState(() => localStorage.getItem("mp_country") || "");
  const [detail, setDetail] = useState(null); // full country doc when slug set

  useEffect(() => {
    http.get("/countries").then(r => setCountries(r.data)).catch(()=>{});
    http.get("/currencies").then(r => setCurrencies(r.data)).catch(()=>{});
  }, []);

  useEffect(() => {
    localStorage.setItem("mp_country", slug || "");
    if (!slug) { setDetail(null); return; }
    http.get(`/countries/${slug}`).then(r => setDetail(r.data)).catch(()=>setDetail(null));
  }, [slug]);

  const country = useMemo(() => countries.find(c => c.slug === slug) || null, [countries, slug]);

  const currency = useMemo(() => {
    if (!country) return DEFAULT_CURRENCY;
    return currencies.find(c => c.code === country.currency) || DEFAULT_CURRENCY;
  }, [country, currencies]);

  const convertFromINR = (inr) => {
    if (!currency || currency.inr_per_unit <= 0 || currency.code === "INR") return null;
    return Math.round(inr / currency.inr_per_unit);
  };
  const format = (amount, curr = currency) => `${curr.symbol} ${Number(amount).toLocaleString()}`;

  const setCountry = (newSlug) => setSlug(newSlug || "");

  return (
    <CountryCtx.Provider value={{ countries, country, slug, setCountry, currency, convertFromINR, format, detail }}>
      {children}
    </CountryCtx.Provider>
  );
}

export function useCountry() {
  const v = useContext(CountryCtx);
  if (!v) throw new Error("useCountry outside CountryProvider");
  return v;
}
